import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
var feed = require("feed-read");
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';


export class FeedItem {
    description: string;
    link: string;
    title: string;

    constructor(description: string, link: string, title: string) {
        this.description = description;
        this.link = link;
        this.title = title;
    }
}

export class Feed {
    title: string;
    url: string;

    constructor(title: string, url: string) {
        this.title = title;
        this.url = url;
    }
}

@Injectable()
export class FeedService {

    private apiModelUrl = environment.apiUrl + 'Resources/';
    private rssToJsonServiceBaseUrl: string = 'https://rss2json.com/api.json?rss_url=';
    identifier = "dock";

    constructor(
        private http: Http
    ) { }


    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }


    //getFeed(url: string): Observable<Feed> {
    //    return feed("http://backend.deviantart.com/rss.xml", function (err, articles) {
    //        if (err) throw err;
    //        // Each article has the following properties:
    //        // 
    //        //   * "title"     - The article title (String).
    //        //   * "author"    - The author's name (String).
    //        //   * "link"      - The original article link (String).
    //        //   * "content"   - The HTML content of the article (String).
    //        //   * "published" - The date that the article was published (Date).
    //        //   * "feed"      - {name, source, link}
    //        // 
    //        console.log(articles);
    //        articles => { return this.articles; }
    //    })
    //        .catch(this.handleError);;
    //}

    //public getArticlesForUrl(url: string) {
    //    var url = "http://backend.deviantart.com/rss.xml";
    //    let articles = [];
    //    return this.http.get(url)
    //        .map(data => data.json()['query']['results'])
    //        .map(res => {
    //            if (res === null) {
    //                return articles;
    //            }
    //            let objects = res['item'];
    //            var length = 20;

    //            for (let i = 0; i < objects.length; i++) {
    //                let item = objects[i];
    //                var trimmedDesc = item.description.length > length ?
    //                    item.description.substring(0, 80) + "..." :
    //                    item.description;
    //                let newFeedItem = new FeedItem(trimmedDesc, item.link, item.title);
    //                articles.push(newFeedItem);
    //            }
    //            return articles;
    //        })
    //}

    getFeed(url): Promise<any> {
        return this.http.get(this.rssToJsonServiceBaseUrl + url)
            .toPromise()
            .then(response => response.json());
    }


    getFeedInfo(): Promise<any> {
        return this.http.get(this.apiModelUrl + this.identifier + "/one")
            .toPromise()
            .then(response => response.json());
    }


    getAssistInfo(): Promise<any> {
        return this.http.get(this.apiModelUrl + "assist" + "/one")
            .toPromise()
            .then(response => response.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/feed.service.ts